export default __webpack_public_path__ + "static/media/logo-white.472460a1.png";